/**
 * Initializes the scroll-to-top button logic.
 */
export function initScrollToTop() {
    const scrollToResultsBtn = document.getElementById('scrollToResultsBtn');
    const scrollToRankingsBtn = document.getElementById('scrollToRankingsBtn');
    const drawer = document.getElementById('rankings-drawer');

    if (scrollToResultsBtn) {
        window.addEventListener('scroll', () => {
            const resultsDiv = document.getElementById('results');
            if (resultsDiv && !resultsDiv.classList.contains('hidden')) {
                const resultsRect = resultsDiv.getBoundingClientRect();
                // Show button when scrolled 300px past the top of the combined results container
                if (resultsRect.top < -300) {
                    scrollToResultsBtn.classList.add('visible');
                } else {
                    scrollToResultsBtn.classList.remove('visible');
                }
            } else {
                scrollToResultsBtn.classList.remove('visible');
            }
        });

        scrollToResultsBtn.addEventListener('click', () => {
            const resultsDiv = document.getElementById('results');
            if (resultsDiv) {
                // Scroll to just above the results title
                const y = resultsDiv.getBoundingClientRect().top + window.scrollY - 20;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        });
    }

    if (scrollToRankingsBtn && drawer) {
        const rankingsContainer = drawer.querySelector('.rankings-container');
        if (rankingsContainer) {
            // Toggle visibility based on drawer scroll position
            rankingsContainer.addEventListener('scroll', () => {
                // Show button after scrolling down 300px within the drawer
                if (rankingsContainer.scrollTop > 300) {
                    scrollToRankingsBtn.classList.add('visible');
                } else {
                    scrollToRankingsBtn.classList.remove('visible');
                }
            });

            scrollToRankingsBtn.addEventListener('click', () => {
                // Scroll the drawer pane back to the top
                rankingsContainer.scrollTo({ top: 0, behavior: 'smooth' });
            });
        }
    }

    // Initialize the inactivity auto-hide for floating actions
    initInactivityHide();
}

/**
 * Auto-hides fixed buttons when the user is analyzing the topmost comparison chart.
 */
export function initInactivityHide() {
    const fixedActions = document.querySelector('.fixed-actions-container');
    if (!fixedActions) return;

    let inactivityTimer = null;
    const INACTIVITY_DELAY = 1200; // 1.2 seconds of inactivity

    function hideButtons() {
        if (isScrolledToResults()) {
            fixedActions.classList.add('inactive');
        }
    }

    function showButtons() {
        fixedActions.classList.remove('inactive');
        resetTimer();
    }

    function resetTimer() {
        if (inactivityTimer) {
            clearTimeout(inactivityTimer);
        }
        inactivityTimer = setTimeout(hideButtons, INACTIVITY_DELAY);
    }

    function isScrolledToResults() {
        const resultsDiv = document.getElementById('results');
        if (!resultsDiv || resultsDiv.classList.contains('hidden')) {
            return false;
        }
        // Check the topmost chart (could be Totals grid, first slot grid, or march projection card)
        const firstChart = resultsDiv.querySelector('.comparison-grid, .scenario-container, .march-projection-card');
        if (!firstChart) {
            return false;
        }
        const rect = firstChart.getBoundingClientRect();
        // Return true if we have scrolled to/past the top edge of the first chart
        return (rect.top <= 300);
    }

    // Listen for both mouse/touch scroll and touch events
    window.addEventListener('scroll', showButtons, { passive: true });
    window.addEventListener('touchstart', showButtons, { passive: true });
    window.addEventListener('touchmove', showButtons, { passive: true });
    window.addEventListener('touchend', showButtons, { passive: true });

    // Run the timer initially
    resetTimer();
}

